import { getUrlFromMultipleQueryParams, UrlParamsReplace } from '.';

export const ADMIN_HOME_PAGE_DISPLAY_DEALS = () => UrlParamsReplace('/admin/homepage-deals');

export const INVESTORS_HOME_PAGE_DISPLAY_DEALS = () => UrlParamsReplace('/homepage-deals');

export const GET_NON_HOME_PAGE_DEALS = (params) => getUrlFromMultipleQueryParams('/admin/non-homepage-deals', params);
